import React from 'react'
export default function HeartIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
            <path d="m8 15.25-1.04-.94c-1.4-1.23-2.54-2.3-3.44-3.17-.9-.89-1.61-1.67-2.13-2.36A7.2 7.2 0 0 1 .3 6.9C.1 6.33 0 5.74 0 5.15 0 3.9.42 2.87 1.27 2.02A4.25 4.25 0 0 1 4.4.75 4.72 4.72 0 0 1 8 2.42 4.72 4.72 0 0 1 11.6.75c1.24 0 2.28.42 3.13 1.27A4.25 4.25 0 0 1 16 5.15c0 .6-.1 1.17-.3 1.72-.19.56-.54 1.18-1.06 1.86-.53.68-1.24 1.47-2.15 2.36-.91.9-2.07 1.99-3.49 3.26l-1 .9Z"/>
        </svg>
    )
}


